"use client"

import { CompletedCollectible, DraftCollectible } from "@/types/collectibles"
import { useAccount, useReadContracts } from "wagmi"
import { getChainId } from "@/util/crypto"
import { erc721ABI } from "@/util/typechain"
import { zeroAddress } from "ethereumjs-util"

export default function useUserHaveToken(
  collectible: CompletedCollectible | DraftCollectible
) {
  const { address: currentUserAddress } = useAccount()

  const contractAddress =
    "contractAddress" in collectible ? collectible.contractAddress : zeroAddress

  const { data, error, isError, isLoading, refetch } = useReadContracts({
    contracts: [
      {
        address: contractAddress as `0x${string}`,
        abi: erc721ABI,
        chainId: getChainId(collectible.chain),
        functionName: "balanceOf",
        args: [
          currentUserAddress || "0x0000000000000000000000000000000000000000",
        ],
      },
    ],
  })

  const balance = data?.[0].result as bigint | undefined

  const hasToken = balance !== undefined && balance > 0n

  return {
    hasToken,
    balance,
    isLoading,
    isError,
    refetch,
    error,
  }
}
